<template>
  <div>
    <div class="row align-items-center">
      <div class="col-md-2 col-12">
        <p class="mb-0 font-weight-bold">Select Section</p>
        <a-spin :spinning="sectionSpinning">
          <a-select
            v-model="sectionId"
            placeholder="All sections"
            optionFilterProp="children"
            style="width: 100%"
            @change="handleSectionChange"
            :filterOption="false"
            :defaultValue="undefined"
            :disabled="!classId"
          >
            <a-select-option :value="undefined" >
              All Sections
            </a-select-option>
            <template v-for="section in sections">
              <a-select-option :value="section.id" :key="section.id">
              {{section.name}}
              </a-select-option>
            </template>
          </a-select>
        </a-spin>
      </div>
      <div class="col-md-6 col-12">
        <p class="mb-0 font-weight-bold">Filter by status</p>
        <div>
          <a-radio-group v-model="filterValue" @change="getStudentsData" :default-data="undefined">
            <a-radio v-for="option in filterOptions" :value="option.value" :key="option.value">
              {{option.label}}
            </a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
    <hr>
    <a-spin :spinning="loading">
      <a-list :data-source="studentData">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <h5 slot="title" class="mb-0">{{ item.student.first_name }} {{ item.student.last_name }}</h5>
            <div slot="description" class="mb-0">
              Std. Code: {{item.student_code}} | Class: {{item.school_class.name}} | Section: {{item.section ? item.section.name : 'N/A'}} | Roll: {{item.roll_no ? item.roll_no : 'N/A'}}
            </div>
            <a-avatar
              slot="avatar"
              :src="item.student.photo"
            />
          </a-list-item-meta>
          <div v-if="item.student_fees[0]">
            <a-tag :color="item.student_fees[0].payment_status ? 'green': 'red'">
              {{getPaymentStatus(item.student_fees[0])}}
            </a-tag>
            <a
              href="javascript:;"
              :class="['p-1 mr-2 text-primary neo-icon-btn', `${item.student_fees[0].payment_status ? 'bg-light text-muted' : ''}`]"
              :disabled="item.student_fees[0].payment_status === 1"
              @click="sendNotification(item)"
            >
              <i class="fe fe-bell" /> Notify
            </a>
          </div>
        </a-list-item>
      </a-list>
    </a-spin>

    <div class="text-right mt-4">
      <hr>
      <a-pagination
          showSizeChanger
          @showSizeChange="onShowSizeChange"
          :total="meta.total"
          :pageSize.sync="pageSize"
          v-model="current"
          @change="onChange"
        >
      </a-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

const filterOptions = [
  { label: 'All', value: undefined },
  { label: 'Paid', value: 1 },
  { label: 'Not Paid', value: 0 },
]

export default {

  name: 'PaymentStatusTable',
  props: {
    feeSetting: {
      type: Object,
      default: () => undefined,
    },
    classId: {
      type: Number,
      default: () => undefined,
    },
    sessionId: {
      type: Number,
      default: () => undefined,
    },
  },
  mounted: function() {
    this.getStudentsData()
    this.getClassSections()
  },
  data: function() {
    return {
      filterOptions,
      loading: false,
      selectedFeeSetting: undefined,
      studentData: [],
      sectionId: undefined,
      sectionSpinning: false,
      sections: [],
      meta: {},
      filterValue: undefined,
      current: 1,
      pageSize: 30,
    }
  },
  watch: {
    data: function(value) {
      this.selectedFeeSetting = undefined
      this.sections = []
    },
  },
  methods: {
    moment,
    getClassSections() {
      this.sectionSpinning = true
      this.$http.get(`/api/section/class/${this.classId}`)
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.sectionId = value
        this.getStudentsData()
      } else {
        this.sectionId = undefined
        this.getStudentsData()
      }
    },
    getStudentsData: function() {
      this.loading = true
      this.$http.get('/api/fee_payment_status', {
        params: {
          limit: this.pageSize,
          page: this.current,
          session_id: this.sessionId,
          class_id: this.classId,
          section_id: this.sectionId,
          fee_setting_id: this.feeSetting.id,
          filter_by: this.filterValue,
        },
      })
        .then(({ data }) => {
          this.studentData = data.data
          this.meta = data.meta
          this.loading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPaymentStatus(value) {
      const status = {
        0: 'Not Paid',
        1: 'Paid',
      }
      return status[value.payment_status]
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudentsData()
    },
    onChange(current) {
      this.current = current
      this.getStudentsData()
    },
    sendNotification(item) {
      console.log(item)
    },
  },
}
</script>
